import { message, Modal } from "antd";
import _ from "lodash";
import Oidc from "oidc-client";
import { BaseAxiosHttpClient } from "./lib/BaseAxiosHttpClient";
const { confirm } = Modal;

class LicenseServiceHttpClient extends BaseAxiosHttpClient {
  constructor() {
    super();
    this.init();
  }
  oidcClient!: Oidc.UserManager;
  private async init() {
    this.getBaseURL();
    this.setDefaultContentType("application/json");
    this.setDefaultAcceptLanguage(this.getLanguage());
    const hostPrefix = `${window.location.protocol}//${window.location.host}`;
    this.oidcClient = new Oidc.UserManager({
      authority: window._settings?.SingleSignOnEndpoint,
      /* eslint-disable */
      client_id: "encoo_console_v3_admin",
      redirect_uri: `${hostPrefix}/callback`,
      silent_redirect_uri: `${hostPrefix}/silent_renew`,
      post_logout_redirect_uri: `${hostPrefix}/index`,
      response_type: "code",
      /* eslint-enable */
      scope: "openid profile apigateway offline_access",
      accessTokenExpiringNotificationTime: 4,
      automaticSilentRenew: false,
      filterProtocolClaims: true,
      response_mode: "query",
      userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
    });
    // 初始化时判断是否有当前用户，当前用户存在切未过期则直接使用
    const crtUser = await this.oidcClient.getUser();
    if (crtUser && !crtUser.expired) {
      this.setDefaultAuthorization(crtUser.access_token);
    } else {
      this.oidcClient.clearStaleState();
      this.oidcClient.removeUser();
      this.oidcClient.signinRedirect();
    }
    this.responseInterceptors();
  }
  private getBaseURL() {
    const setting = window._settings;
    if (setting && setting.licenseServiceEndpoint) {
      if (_.endsWith(setting.licenseServiceEndpoint, "/")) {
        this.setDefaultConfig(
          "baseURL",
          setting.licenseServiceEndpoint.slice(
            0,
            setting.licenseServiceEndpoint.length - 1
          )
        );
      } else {
        this.setDefaultConfig("baseURL", setting.licenseServiceEndpoint);
      }
    }
  }
  private getLanguage(): string {
    const localStorage: Storage = window.localStorage;
    let lang = localStorage?.getItem("encoo_locale") ?? "";
    if (-1 === lang.indexOf("en")) {
      // eslint-disable-next-line eqeqeq
      if (-1 == lang.indexOf("ja-JP")) {
        lang = "zh-CN,zh;q=0.9";
      } else {
        lang = "ja-JP,zh;q=0.9";
      }
    } else lang = "en-US,zh;q=0.9";
    return lang;
  }
  private responseInterceptors() {
    this.axiosClient.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error?.response?.status === 401) {
          window.sessionStorage.removeItem("Authorization");
          confirm({
            title: "提示",
            content: "当前登录已过期，请点击“确认”重新登录！",
            onOk() {
              licenseServiceHttpClient.oidcClient.clearStaleState();
              licenseServiceHttpClient.oidcClient.removeUser().finally(() => {
                licenseServiceHttpClient.oidcClient.signinRedirect();
              });
            },
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onCancel() {},
          });
        } else if (error?.response?.status === 403) {
          Modal.warning({
            title: "提示",
            content: "用户无权限！",
          });
        } else {
          message.error(error?.response?.data?.message);
        }
        return Promise.reject(error);
      }
    );
  }
}
export const licenseServiceHttpClient = new LicenseServiceHttpClient();
